const translation = {
  // Navbar
  nav_home: 'Inicio',
  nav_services: 'Servicios',
  nav_about: 'Nosotros',
  nav_reviews: 'Opiniones',
  nav_quote: 'Cotización Gratis',

  // Hero
  hero_badge: 'Limpieza Profesional & Garantizada',
  hero_title1: 'Tu Hogar Merece',
  hero_title2: 'Brillar Siempre',
  hero_desc: 'Limpieza residencial, lavado a presión, ventanas, post-mudanza y más. Servicio impecable en The Villages, FL y alrededores.',
  hero_cta1: 'Cotización Gratis',
  hero_cta2: 'Ver Servicios',
  hero_stat1: 'Satisfacción Garantizada',
  hero_stat2: 'Respuesta en 24h',
  hero_stat3: 'Cotización Gratis',

  // Services Preview
  sp_eyebrow: 'Lo Que Hacemos',
  sp_heading: 'Nuestros Servicios',
  sp_sub: 'Ofrecemos soluciones de limpieza profesional para todo tipo de propiedades residenciales y comunidades de condominios.',
  sp_details: 'Ver detalles',
  sp_all: 'Ver Todos los Servicios',

  // About Preview
  ap_eyebrow: 'Quiénes Somos',
  ap_heading: 'Limpieza Profesional con el',
  ap_heading_accent: 'Corazón Puesto',
  ap_heading_end: 'en Cada Detalle',
  ap_p1: 'Somos una empresa familiar dedicada a transformar espacios con limpieza de alta calidad. Desde limpieza post-mudanza hasta servicios de valet trash para condominios, nuestro equipo capacitado garantiza resultados excepcionales en cada trabajo.',
  ap_p2: 'Usamos productos de limpieza de primera calidad y técnicas probadas para asegurar que cada rincón quede impecable. Tu hogar o propiedad merece el mejor cuidado.',
  ap_clients: '100% Garantizado',
  ap_area: 'Tu satisfacción, nuestra prioridad',
  ap_exp: 'Años de Experiencia',
  ap_val1_t: 'Confianza',
  ap_val1_d: 'Personal verificado y de confianza en cada visita.',
  ap_val2_t: 'Calidad',
  ap_val2_d: 'Productos premium y técnicas profesionales.',
  ap_val3_t: 'Puntualidad',
  ap_val3_d: 'Llegamos cuando lo prometemos, siempre.',
  ap_val4_t: 'Compromiso',
  ap_val4_d: 'Tu satisfacción es nuestra garantía.',
  ap_cta: 'Conoce Más Sobre Nosotros',

  // Testimonials / Guarantees section
  rev_eyebrow: 'Nuestra Promesa',
  rev_heading: 'Comprometidos con Tu Satisfacción',
  rev_sub: 'Comenzamos con el compromiso de hacer cada trabajo perfectamente desde el primer día.',
  rev_all: 'Ver todas las opiniones',

  // Guarantee cards
  guar_t1: 'Satisfacción 100% Garantizada',
  guar_d1: 'Si no quedas completamente satisfecho, regresamos a corregirlo sin costo adicional.',
  guar_t2: 'Personal Verificado',
  guar_d2: 'Cada miembro del equipo pasa por verificación de antecedentes y capacitación profesional.',
  guar_t3: 'Productos Eco-Friendly',
  guar_d3: 'Solo usamos productos seguros para tu familia, mascotas y el medio ambiente.',
  guar_t4: 'Puntualidad Garantizada',
  guar_d4: 'Llegamos a la hora acordada o te avisamos con anticipación. Tu tiempo vale.',
  guar_first_h: '¡Sé Nuestro Primer Cliente!',
  guar_first_d: 'Estamos comenzando a escribir nuestra historia y queremos que seas parte de ella. Obtén un servicio impecable con garantía total desde el primer día.',
  guar_first_btn: 'Obtener Cotización Gratis',

  // CTA Section
  cta_badge: '¿Listo para Empezar?',
  cta_heading: 'Obtén Tu Cotización',
  cta_heading_accent: 'Gratis',
  cta_heading_end: 'Hoy',
  cta_desc: 'Sin compromisos. Te enviamos una cotización personalizada en menos de 24 horas. Servicio disponible en The Villages, FL y alrededores.',
  cta_btn: 'Solicitar Cotización Gratis',
  cta_trust1: 'Personal Asegurado',
  cta_trust2: 'Satisfacción Garantizada',
  cta_trust3: 'Empresa Verificada',
  cta_trust4: 'Productos Eco-Friendly',

  // Footer
  ft_desc: 'Transformamos espacios con limpieza profesional de calidad. Tu satisfacción es nuestra prioridad.',
  ft_services: 'Servicios',
  ft_svc1: 'Limpieza Post-Mudanza',
  ft_svc2: 'Limpieza de Ventanas',
  ft_svc3: 'Lavado a Presión',
  ft_svc4: 'Valet Trash',
  ft_company: 'Empresa',
  ft_c1: 'Sobre Nosotros',
  ft_c2: 'Opiniones',
  ft_c3: 'Servicios',
  ft_contact: 'Contacto',
  ft_hours: 'Lun–Sáb: 8am – 6pm',
  ft_copyright: 'Todos los derechos reservados.',
  ft_tagline: 'Servicio profesional de limpieza residencial en The Villages, FL',

  // Services Page
  svcp_badge: 'Lo Que Ofrecemos',
  svcp_title: 'Nuestros Servicios',
  svcp_desc: 'Soluciones de limpieza profesional para residencias y comunidades de condominios en The Villages, FL y alrededores.',
  svcp_quote_btn: 'Cotizar Este Servicio',
  svcp_why: '¿Por Qué Elegirnos?',
  svcp_w1_t: 'Equipo Certificado',
  svcp_w1_d: 'Personal entrenado y verificado.',
  svcp_w2_t: 'Productos Seguros',
  svcp_w2_d: 'Eco-friendly y no tóxicos.',
  svcp_w3_t: 'Atención Personalizada',
  svcp_w3_d: 'Cotizaciones adaptadas a tu necesidad.',
  svcp_w4_t: 'Precios Transparentes',
  svcp_w4_d: 'Sin costos ocultos, precio justo.',
  svcp_cta_t: '¿Listo para agendar tu servicio?',
  svcp_cta_d: 'Respuesta garantizada en menos de 24 horas.',
  svcp_cta_btn: 'Obtener Cotización',

  // About Page
  abp_badge: 'Conoce Nuestra Historia',
  abp_title: 'Sobre Nosotros',
  abp_desc: 'Somos una empresa familiar comprometida con transformar cada espacio en un lugar impecable, con pasión y profesionalismo.',
  abp_ess: 'Nuestra Esencia',
  abp_h2: 'Limpiar es Nuestro Arte,',
  abp_h2_accent: 'Tu Satisfacción',
  abp_h2_end: 'Nuestra Meta',
  abp_p1: 'Nacimos de la convicción de que un hogar limpio es un hogar feliz. Cada espacio que tocamos recibe el mismo cuidado y atención que le daríamos a nuestra propia casa.',
  abp_p2: 'Combinamos técnicas avanzadas, productos de alta calidad y un equipo apasionado para ofrecer resultados que superan expectativas. Desde limpieza post-mudanza hasta valet trash para condominios.',
  abp_mission_t: 'Misión',
  abp_mission_d: 'Ofrecer servicios de limpieza excepcionales que mejoren la calidad de vida de nuestros clientes.',
  abp_vision_t: 'Visión',
  abp_vision_d: 'Ser la empresa de limpieza más reconocida y confiable de The Villages, FL y sus alrededores.',
  abp_stat1: 'Garantía Total',
  abp_stat2: 'Cotización',
  abp_timeline_tag: 'Nuestra Historia',
  abp_timeline_h: 'Comenzando a Crecer Contigo',
  abp_team_tag: 'Las Personas Detrás',
  abp_team_h: 'Nuestro Equipo',
  abp_val_h: 'Nuestros Valores',
  abp_v1_t: 'Integridad',
  abp_v1_d: 'Honestidad y transparencia en cada interacción.',
  abp_v2_t: 'Excelencia',
  abp_v2_d: 'No paramos hasta que quede perfecto.',
  abp_v3_t: 'Respeto',
  abp_v3_d: 'Tu hogar y privacidad son sagrados para nosotros.',
  abp_v4_t: 'Responsabilidad',
  abp_v4_d: 'Cuidamos el medio ambiente en nuestros procesos.',
  abp_cta_t: 'Trabaja con un Equipo en el que Puedes Confiar',
  abp_cta_d: 'Da el primer paso con una empresa que pone tu satisfacción por encima de todo. Servicio profesional en The Villages, FL.',
  abp_cta_btn: 'Solicitar Cotización Gratis',
  abp_m1_t: 'Nació el Sueño',
  abp_m1_d: 'Con la pasión de transformar hogares, tomamos la decisión de emprender en The Villages, FL.',
  abp_m2_t: 'Lanzamiento Oficial',
  abp_m2_d: 'Abrimos nuestras puertas y comenzamos a ofrecer nuestros servicios a la comunidad local.',
  abp_m3_t: 'En Búsqueda del Primer Cliente',
  abp_m3_d: 'Estamos listos para demostrar nuestro profesionalismo. ¡Sé el primero en confiar en nosotros!',
  abp_m4_t: 'Nuestra Meta para 2026',
  abp_m4_d: 'Convertirnos en la empresa de limpieza de confianza #1 en toda el área de The Villages, FL.',
  abp_tr1: 'Fundadora & Directora',
  abp_tb1: 'Con más de 10 años en la industria de limpieza, Rosa fundó la empresa con la visión de ofrecer un servicio que combinara calidad excepcional con un trato familiar.',
  abp_tr2: 'Supervisor de Operaciones',
  abp_tb2: 'Carlos coordina todos los equipos en campo para asegurar que cada trabajo cumpla con nuestros estándares de calidad y puntualidad.',
  abp_tr3: 'Especialista en Limpieza de Ventanas',
  abp_tb3: 'Lucía lidera nuestro equipo de limpieza de ventanas residenciales y comerciales, con amplia experiencia en técnicas de limpieza sin rayas y manejo de superficies delicadas.',

  // Reviews Page
  revp_badge: 'Opiniones',
  revp_title: 'Opiniones de Clientes',
  revp_desc: 'Estamos comenzando a escribir nuestra historia. Sé de los primeros en experimentar nuestro servicio y comparte tu opinión.',
  revp_avg: 'Calificación Promedio',
  revp_based: 'Basado en {{count}} reseñas',
  revp_all: 'Todos',
  revp_cta_t: '¡Sé Nuestro Primer Cliente!',
  revp_cta_d: 'Comenzamos con el compromiso de superar tus expectativas. Solicita tu cotización y sé parte de nuestra historia en The Villages, FL.',
  revp_cta_btn: 'Solicitar Cotización Gratis',
  revp_empty: 'No hay reseñas para este filtro.',
  revp_empty_h: '¡Aún No Hay Reseñas!',
  revp_empty_d: 'Somos un negocio nuevo y queremos ganarnos tu confianza. Sé el primero en probar nuestro servicio y contarnos tu experiencia.',
  sf_all: 'Todos',
  sf_move_out: 'Limpieza Post-Mudanza',
  sf_new_construction: 'Nueva Construcción',
  sf_windows: 'Limpieza de Ventanas',
  sf_pressure: 'Lavado a Presión',
  sf_valet: 'Valet Trash - Condominio',

  // Quote Modal
  qm_title: 'Solicitar Cotización',
  qm_sub: 'Respuesta en menos de 24 horas',
  qm_name: 'Nombre',
  qm_name_ph: 'Tu nombre',
  qm_phone: 'Teléfono',
  qm_phone_ph: '(305) 000-0000',
  qm_email_label: 'Correo Electrónico',
  qm_email_ph: 'tu@email.com',
  qm_service: 'Servicio de Interés',
  qm_service_ph: 'Selecciona un servicio',
  qm_svc1: 'Limpieza Post-Mudanza',
  qm_svc2: 'Limpieza de Ventanas',
  qm_svc3: 'Lavado a Presión',
  qm_svc4: 'Valet Trash Pick-Up',
  qm_svc5: 'Múltiples Servicios',
  qm_address: 'Dirección / Ciudad',
  qm_address_ph: 'Ciudad o dirección aproximada',
  qm_details: 'Detalles adicionales',
  qm_details_ph: 'Cuéntanos más sobre tu propiedad o necesidades específicas...',
  qm_btn: 'Enviar Solicitud de Cotización',
  qm_loading: 'Enviando...',
  qm_success_t: '¡Solicitud Enviada!',
  qm_success_d: 'Nos pondremos en contacto contigo en menos de 24 horas con tu cotización personalizada.',
  qm_close: 'Cerrar',

  // Floating button
  fb_text: 'Cotización Gratis',
};

export default translation;
